export default function LoadingSpinner({ size = 'md', className = '', fullScreen = false }) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  }

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
        <div className="text-center bg-white rounded-2xl shadow-2xl p-8 transform hover:scale-105 transition-transform duration-200">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-slate-200 border-t-slate-900 mx-auto mb-4" />
          <div className="text-slate-600 font-medium">Loading...</div>
        </div>
      </div>
    )
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className={`animate-spin rounded-full border-2 border-slate-200 border-t-slate-900 ${sizeClasses[size]}`} />
    </div>
  )
}
